import { Checkbox as BaseCheckbox } from "@base-ui/react/checkbox";
import checkIcon from "@loot-os/icons/icons/check";
import minusIcon from "@loot-os/icons/icons/minus";
import type { ComponentProps, ReactNode } from "react";

import { cn } from "../foundations/cn.js";
import { CHECKBOX_BOX } from "./Checkbox.styles.js";
import { Icon } from "./Icon.js";

export interface CheckboxProps
  extends Omit<ComponentProps<typeof BaseCheckbox.Root>, "className" | "children"> {
  /** The label beside the box, and its name. */
  children: ReactNode;
  className?: string;
}

/** One independent yes/no in a form or filter list. */
export function Checkbox({ children, className, ...props }: CheckboxProps) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: Base UI's checkbox root is the control inside it.
    <label
      className={cn(
        "inline-flex cursor-pointer items-center gap-2.5 font-body text-body-b2 text-text-secondary has-data-disabled:cursor-default has-data-disabled:text-text-disabled",
        className,
      )}
    >
      <BaseCheckbox.Root className={CHECKBOX_BOX} {...props}>
        <BaseCheckbox.Indicator
          render={(indicatorProps, state) => (
            <span {...indicatorProps}>
              <Icon icon={state.indeterminate ? minusIcon : checkIcon} size={14} />
            </span>
          )}
        />
      </BaseCheckbox.Root>
      {children}
    </label>
  );
}
